import { FC, ReactNode, useRef, useState } from 'react';
import styles from '../../assets/scss/ProductDescModal/ProductAccordion.module.scss';

type ProductAccordionProps = {
  image: string;
  title: string;
  children: ReactNode;
};

export const ProductAccordion: FC<ProductAccordionProps> = ({ image, title, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const bodyRef = useRef<HTMLDivElement>(null);

  const toggleOpen = () => {
    const el = bodyRef.current;
    if (!el) return;

    if (isOpen) {
      // close: max-heightを0に
      el.style.maxHeight = '0px';
    } else {
      // open: scrollHeight を max-height にセット
      el.style.maxHeight = el.scrollHeight + 'px';
    }
    setIsOpen((prev) => !prev);
  };

  const cleanedTitle = title
    .replace(/<[^>]+>/g, '') // HTMLタグを除去
    .replace(/\s+/g, ' ') // 連続の半角スペースを1つに圧縮
    .trim(); // 前後の不要スペース削除

  return (
    <div className={styles.accordion}>
      <button
        className={`${styles.header} ${isOpen ? styles.headerOpen : ''}`}
        type="button"
        onClick={toggleOpen}
      >
        {image ? (
          <img
            className={styles.headerImg}
            src={image}
            alt=""
          />
        ) : (
          <div
            className={styles.headerImg}
            style={{ backgroundColor: '#c4c4c4' }}
          />
        )}
        {/* HTMLタグを除去 */}
        <p className={styles.headerTitle}>
          {cleanedTitle.split(' ').map((text, i) => (
            <span key={i}>{text}</span>
          ))}
        </p>
        <span className={`${isOpen ? styles.angleUp : styles.angleDw}`} />
      </button>

      {/* アコーディオン内 */}
      <div
        ref={bodyRef}
        className={styles.body}
      >
        <div className={styles.inner}>
          {children}
          <button
            className={styles.closeBtn}
            onClick={toggleOpen}
          >
            閉じる
          </button>
        </div>
      </div>
    </div>
  );
};
